'use strict';

import { Entity } from '../Entity';
import { Ind } from '../Ind/Ind';
import { User } from './User';

export class UserSoa extends Entity {
  protected soaId;
  protected soaUuid;
  protected soaTransmissionAddress;
  protected soaAgentName;
  protected soaAgentPhone;
  protected soaAgentSignature;
  protected soaAgentSignDate;
  protected soaAgentInpersonAttestation;
  protected soaAgentIp;
  protected soaAgentNpn;
  protected soaBeneficiaryPhone;
  protected soaBeneficiaryName;
  protected soaBeneficiaryAddress;
  protected soaBeneficiarySignature;
  protected soaBeneficiarySignDate;
  protected soaBeneficiaryInpersonAttestation;
  protected soaAuthRepName;
  protected soaAuthRepRelation;
  protected soaDiscussionCheck;
  protected soaBeneficiaryIp;
  protected soaInitialContactMethod;
  protected soaDiscussedPlans;
  protected soaAppointmentDate;
  protected soaAccessCode;
  protected soaState;
  protected soaDocId;
  protected soaCreatedDate;
  protected soaTransmissionMethod;
  protected isConsent;
  protected soaType;
  protected soaIncomeYear;
  protected soaIncome;
  protected soaReviewDate;
  protected soaLanguage;
  protected signatureImagePath;
  protected signatureImageSignedUrl;
  protected ind;
  protected soaUrl;
  protected code;
  protected soaTimezoneOffset;
  protected consentCompany;
  protected consentEffective;
  protected consentPlan;
  protected consentSubsidy;
  protected consentPremium;
  protected soaAgentSignaturePath;
  protected agentSignatureImageSignedUrl;
  protected user;
  protected external;
  protected soaExternalSrc;
  protected externalName;
  protected soaNoAuth;
  protected otherDocName;

  protected soaBeneficiarySignDateRaw;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.soaId = data.soaId;
    this.soaUuid = data.soaUuid;
    this.soaAgentName = data.soaAgentName;
    this.soaAgentPhone = data.soaAgentPhone;
    this.soaAgentSignature = data.soaAgentSignature;
    this.soaAgentInpersonAttestation = data.soaAgentInpersonAttestation;
    this.soaAgentIp = data.soaAgentIp;
    this.soaAgentNpn = data.soaAgentNpn;
    this.soaBeneficiaryPhone = data.soaBeneficiaryPhone;
    this.soaBeneficiaryName = data.soaBeneficiaryName;
    this.soaBeneficiaryAddress = data.soaBeneficiaryAddress;
    this.soaBeneficiarySignature = data.soaBeneficiarySignature;
    this.soaBeneficiaryInpersonAttestation = data.soaBeneficiaryInpersonAttestation;
    this.soaAuthRepName = data.soaAuthRepName;
    this.soaAuthRepRelation = data.soaAuthRepRelation;
    this.soaDiscussionCheck = data.soaDiscussionCheck;
    this.soaBeneficiaryIp = data.soaBeneficiaryIp;
    this.soaDiscussedPlans = data.soaDiscussedPlans;
    this.soaAccessCode = data.soaAccessCode;
    this.soaState = data.soaState;
    this.soaDocId = data.soaDocId;
    this.soaTransmissionMethod = data.soaTransmissionMethod;
    this.soaTransmissionAddress = data.soaTransmissionAddress;
    this.isConsent = data.isConsent;
    this.soaIncomeYear = data.soaIncomeYear;
    this.soaIncome = data.soaIncome;
    this.soaLanguage = data.soaLanguage;
    this.signatureImagePath = data.signatureImagePath;
    this.signatureImageSignedUrl = null;
    this.soaInitialContactMethod = data.soaInitialContactMethod;
    this.consentCompany = data.consentCompany;
    this.consentEffective = data.consentEffective;
    this.consentPlan = data.consentPlan;
    this.consentSubsidy = data.consentSubsidy;
    this.consentPremium = data.consentPremium;
    this.soaAgentSignaturePath = data.soaAgentSignaturePath;
    this.agentSignatureImageSignedUrl = null;
    this.user = data.user;
    this.external = data.external;
    this.soaExternalSrc = data.soaExternalSrc;
    this.externalName = data.externalName;
    this.soaBeneficiarySignDateRaw = data.soaBeneficiarySignDate;
    this.soaNoAuth = data.soaNoAuth;
    this.otherDocName = data.otherDocName;

    if (data.code) {
      this.code = data.code;
    }

    if (data.soaCreatedDate) {
      const soaCreatedDate = data.soaCreatedDate.date.split(' ')[0].split('-');
      this.soaCreatedDate = soaCreatedDate[1] + '/' + soaCreatedDate[2] + '/' + soaCreatedDate[0];
    }

    if (data.soaAppointmentDate) {
      const soaAppointmentDate = data.soaAppointmentDate.date.split(' ')[0].split('-');
      this.soaAppointmentDate =
        soaAppointmentDate[1] + '/' + soaAppointmentDate[2] + '/' + soaAppointmentDate[0];
    }

    if (data.soaBeneficiarySignDate) {
      const soaBeneficiarySignDate = data.soaBeneficiarySignDate.date.split(' ')[0].split('-');
      this.soaBeneficiarySignDate =
        soaBeneficiarySignDate[1] +
        '/' +
        soaBeneficiarySignDate[2] +
        '/' +
        soaBeneficiarySignDate[0];
    }

    if (data.soaReviewDate) {
      const soaReviewDate = data.soaReviewDate.date.split(' ')[0].split('-');
      this.soaReviewDate = soaReviewDate[1] + '/' + soaReviewDate[2] + '/' + soaReviewDate[0];
    }

    if (data.soaAgentSignDate) {
      const soaAgentSignDate = data.soaAgentSignDate.date.split(' ')[0].split('-');
      this.soaAgentSignDate =
        soaAgentSignDate[1] + '/' + soaAgentSignDate[2] + '/' + soaAgentSignDate[0];
    }

    if (data.consentEffective) {
      const consentEffective = data.consentEffective.date.split(' ')[0].split('-');
      this.consentEffective =
        consentEffective[1] + '/' + consentEffective[2] + '/' + consentEffective[0];
    }

    if (data.ind) {
      const ind = new Ind();
      ind.hydrate(data.ind);

      this.ind = ind;
    }

    if (data.user) {
      const user = new User();
      user.hydrate(data.user);

      this.user = user;
    }
  }

  public getCode() {
    return this.code;
  }

  public getUrlClient() {
    const protocol = window.location.hostname.indexOf('localhost') >= 0 ? 'http://' : 'https://';
    const portalurl = protocol + window.location.hostname + '/agent/soa/auth/' + this.getSoaUuid();

    return portalurl;
  }

  public getUrlAgent() {
    const protocol = window.location.hostname.indexOf('localhost') >= 0 ? 'http://' : 'https://';
    const portalurl =
      protocol + window.location.hostname + '/agent/soa/' + this.getSoaUuid() + '/agent';

    return portalurl;
  }

  public getSoaId() {
    return this.soaId;
  }

  public getInd() {
    return this.ind;
  }

  public getSoaUuid() {
    return this.soaUuid;
  }

  public setSoaUuid(soaUuid) {
    this.soaUuid = soaUuid;
    return this;
  }

  public getSoaTransmissionMethod() {
    return this.soaTransmissionMethod;
  }

  public setSoaTransmissionMethod(soaTransmissionMethod) {
    this.soaTransmissionMethod = soaTransmissionMethod;
    return this;
  }

  public getSoaTransmissionAddress() {
    return this.soaTransmissionAddress;
  }

  public setSoaTransmissionAddress(soaTransmissionAddress) {
    this.soaTransmissionAddress = soaTransmissionAddress;
    return this;
  }

  public getSoaTimezoneOffset() {
    return this.soaTimezoneOffset;
  }

  public setSoaTimezoneOffset(soaTimezoneOffset) {
    this.soaTimezoneOffset = soaTimezoneOffset;
    return this;
  }

  public getSoaAgentName() {
    return this.soaAgentName;
  }

  public setSoaAgentName(soaAgentName) {
    this.soaAgentName = soaAgentName;
    return this;
  }

  public getSoaAgentPhone() {
    return this.soaAgentPhone;
  }

  public setSoaAgentPhone(soaAgentPhone) {
    this.soaAgentPhone = soaAgentPhone;
    return this;
  }

  public getSoaAgentSignature() {
    return this.soaAgentSignature;
  }

  public setSoaAgentSignature(soaAgentSignature) {
    this.soaAgentSignature = soaAgentSignature;
    return this;
  }

  public getSoaAgentSignDate() {
    return this.soaAgentSignDate;
  }

  public setSoaAgentSignDate(soaAgentSignDate) {
    this.soaAgentSignDate = soaAgentSignDate;
    return this;
  }

  public getSoaAgentInpersonAttestation() {
    return this.soaAgentInpersonAttestation;
  }

  public setSoaAgentInpersonAttestation(soaAgentInpersonAttestation) {
    this.soaAgentInpersonAttestation = soaAgentInpersonAttestation;
    return this;
  }

  public getSoaAgentIp() {
    return this.soaAgentIp;
  }

  public setSoaAgentIp(soaAgentIp) {
    this.soaAgentIp = soaAgentIp;
    return this;
  }

  public getSoaAgentNpn() {
    return this.soaAgentNpn;
  }

  public setSoaAgentNpn(soaAgentNpn) {
    this.soaAgentNpn = soaAgentNpn;
    return this;
  }

  public getUser() {
    return this.user;
  }

  public setUser(user) {
    this.user = user;
    return this;
  }

  public getSoaBeneficiaryPhone() {
    return this.soaBeneficiaryPhone;
  }

  public setSoaBeneficiaryPhone(soaBeneficiaryPhone) {
    this.soaBeneficiaryPhone = soaBeneficiaryPhone;
    return this;
  }

  public getSoaBeneficiaryName() {
    return this.soaBeneficiaryName;
  }

  public setSoaBeneficiaryName(soaBeneficiaryName) {
    this.soaBeneficiaryName = soaBeneficiaryName;
    return this;
  }

  public getSoaBeneficiaryAddress() {
    return this.soaBeneficiaryAddress;
  }

  public setSoaBeneficiaryAddress(soaBeneficiaryAddress) {
    this.soaBeneficiaryAddress = soaBeneficiaryAddress;
    return this;
  }

  public getSoaBeneficiarySignature() {
    return this.soaBeneficiarySignature;
  }

  public setSoaBeneficiarySignature(soaBeneficiarySignature) {
    this.soaBeneficiarySignature = soaBeneficiarySignature;
    return this;
  }

  public getSoaBeneficiarySignDate() {
    return this.soaBeneficiarySignDate;
  }

  public setSoaBeneficiarySignDate(soaBeneficiarySignDate) {
    this.soaBeneficiarySignDate = soaBeneficiarySignDate;
    return this;
  }

  public getSoaBeneficiarySignDateRaw() {
    console.log(this.soaBeneficiarySignDateRaw.date);
    const date = new Date(this.soaBeneficiarySignDateRaw.date.replace(' ', 'T').slice(0, 23));
    return date;
  }

  public getSoaBeneficiaryInpersonAttestation() {
    return this.soaBeneficiaryInpersonAttestation;
  }

  public setSoaBeneficiaryInpersonAttestation(soaBeneficiaryInpersonAttestation) {
    this.soaBeneficiaryInpersonAttestation = soaBeneficiaryInpersonAttestation;
    return this;
  }

  public getSoaAuthRepName() {
    return this.soaAuthRepName;
  }

  public setSoaAuthRepName(soaAuthRepName) {
    this.soaAuthRepName = soaAuthRepName;
    return this;
  }

  public getSoaAuthRepRelation() {
    return this.soaAuthRepRelation;
  }

  public setSoaAuthRepRelation(soaAuthRepRelation) {
    this.soaAuthRepRelation = soaAuthRepRelation;
    return this;
  }

  public getSoaDiscussionCheck() {
    return this.soaDiscussionCheck;
  }

  public setSoaDiscussionCheck(soaDiscussionCheck) {
    this.soaDiscussionCheck = soaDiscussionCheck;
    return this;
  }

  public getSoaBeneficiaryIp() {
    return this.soaBeneficiaryIp;
  }

  public setSoaBeneficiaryIp(soaBeneficiaryIp) {
    this.soaBeneficiaryIp = soaBeneficiaryIp;
    return this;
  }

  public getSoaInitialContactMethod() {
    return this.soaInitialContactMethod;
  }

  public setSoaInitialContactMethod(soaInitialContactMethod) {
    this.soaInitialContactMethod = soaInitialContactMethod;
    return this;
  }

  public getSoaDiscussedPlans() {
    return this.soaDiscussedPlans;
  }

  public setSoaDiscussedPlans(soaDiscussedPlans) {
    this.soaDiscussedPlans = soaDiscussedPlans;
    return this;
  }

  public getSoaAccessCode() {
    return this.soaAccessCode;
  }

  public setSoaAccessCode(soaAccessCode) {
    this.soaAccessCode = soaAccessCode;
    return this;
  }

  public getSoaState() {
    return this.soaState;
  }

  public setSoaState(soaState) {
    this.soaState = soaState;
    return this;
  }

  public getSoaCreatedDate() {
    return this.soaCreatedDate;
  }

  public setSoaCreatedDate(soaCreatedDate) {
    this.soaCreatedDate = soaCreatedDate;
    return this;
  }

  public getSoaAppointmentDate() {
    return this.soaAppointmentDate;
  }

  public setSoaAppointmentDate(soaAppointmentDate) {
    this.soaAppointmentDate = soaAppointmentDate;
    return this;
  }

  public getIsConsent() {
    return this.isConsent;
  }

  public setIsConsent(isConsent) {
    this.isConsent = isConsent;
    return this;
  }

  public getSoaIncomeYear() {
    return this.soaIncomeYear;
  }

  public setSoaIncomeYear(soaIncomeYear) {
    this.soaIncomeYear = soaIncomeYear;
    return this;
  }

  public getSoaIncome() {
    return this.soaIncome;
  }

  public setSoaIncome(soaIncome) {
    this.soaIncome = soaIncome;
    return this;
  }

  public getSoaReviewDate() {
    return this.soaReviewDate;
  }

  public setSoaReviewDate(soaReviewDate) {
    this.soaReviewDate = soaReviewDate;
    return this;
  }

  public getSoaLanguage() {
    return this.soaLanguage;
  }

  public setSoaLanguage(soaLanguage) {
    this.soaLanguage = soaLanguage;
    return this;
  }

  public getSignatureImagePath() {
    return this.signatureImagePath;
  }

  public setSignatureImagePath(signatureImagePath) {
    this.signatureImagePath = signatureImagePath;
    return this;
  }

  public getSignatureImageSignedUrl(): string {
    return this.signatureImageSignedUrl;
  }

  public setSignatureImageSignedUrl(signatureImageSignedUrl) {
    this.signatureImageSignedUrl = signatureImageSignedUrl;

    return this;
  }

  public getConsentCompany() {
    return this.consentCompany;
  }

  public setConsentCompany(consentCompany) {
    this.consentCompany = consentCompany;
    return this;
  }

  public getConsentEffective() {
    return this.consentEffective;
  }

  public setConsentEffective(consentEffective) {
    this.consentEffective = consentEffective;
    return this;
  }

  public getConsentPlan() {
    return this.consentPlan;
  }

  public setConsentPlan(consentPlan) {
    this.consentPlan = consentPlan;
    return this;
  }

  public getConsentSubsidy() {
    return this.consentSubsidy;
  }

  public setConsentSubsidy(consentSubsidy) {
    this.consentSubsidy = consentSubsidy;
    return this;
  }

  public getConsentPremium() {
    return this.consentPremium;
  }

  public setConsentPremium(consentPremium) {
    this.consentPremium = consentPremium;
    return this;
  }

  public getSoaAgentSignaturePath() {
    return this.soaAgentSignaturePath;
  }

  public setSoaAgentSignaturePath(soaAgentSignaturePath) {
    this.soaAgentSignaturePath = soaAgentSignaturePath;
    return this;
  }

  public getAgentSignatureImageSignedUrl(): string {
    return this.agentSignatureImageSignedUrl;
  }

  public setAgentSignatureImageSignedUrl(agentSignatureImageSignedUrl) {
    this.agentSignatureImageSignedUrl = agentSignatureImageSignedUrl;

    return this;
  }

  public isExternal() {
    return this.external;
  }

  public setExternal(external) {
    this.external = external;
    return this;
  }

  public getSoaExternalSrc() {
    return this.soaExternalSrc;
  }

  public setSoaExternalSrc(soaExternalSrc) {
    this.soaExternalSrc = soaExternalSrc;
    return this;
  }

  public getExternalName() {
    return this.externalName;
  }

  public setExternalName(externalName) {
    this.externalName = externalName;
    return this;
  }

  public isSoaNoAuth() {
    return this.soaNoAuth;
  }

  public setSoaNoAuth(soaNoAuth) {
    this.soaNoAuth = soaNoAuth;
    return this;
  }

  public getOtherDocName() {
    return this.otherDocName;
  }

  public setOtherDocName(otherDocName) {
    this.otherDocName = otherDocName;
    return this;
  }

  public getSoaType() {
    this.soaType = 'SOA';

    if (this.isConsent == 1) {
      this.soaType = 'Consent (A)';
    }

    if (this.isConsent == 2) {
      this.soaType = 'Consent (B)';
    }

    if (this.isConsent == 3) {
      this.soaType = this.otherDocName;
    }

    return this.soaType;
  }

  public getSoaValue() {
    this.soaType = 'soa';

    if (this.isConsent == 1) {
      this.soaType = 'consentA';
    }

    if (this.isConsent == 2) {
      this.soaType = 'consentB';
    }

    return this.soaType;
  }
}
